import { JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { RoleNameInterface } from 'src/app/core/domain/data/role-name.interface';

@JsonObject('RoleName')
export class RoleName implements RoleNameInterface {
    @JsonProperty('Id', StringAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    get id(): Id {
        return this._id;
    }

    get name(): string {
        return this._name;
    }
}
